import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickMoodPresets = ({ onPresetSelect }) => {
  const presets = [];

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-heading font-semibold text-foreground">
        Quick Presets
      </h3>
      <p className="text-sm text-muted-foreground">
        Select a preset to quickly update your mood
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {presets?.map((preset) => (
          <button
            key={preset?.id}
            onClick={() => onPresetSelect(preset)}
            className="flex flex-col items-center space-y-2 p-4 rounded-md border border-border bg-card hover:border-primary/30 hover:bg-primary/5 transition-therapeutic"
          >
            <div className="flex items-center justify-center w-12 h-12 rounded-md bg-muted">
              <Icon name={preset?.icon} size={24} color="var(--color-primary)" />
            </div>
            <span className="text-sm font-medium text-foreground text-center">
              {preset?.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickMoodPresets;